<template>
  <div v-if="$wp.pagesLoaded" class="layout">
    <NavigationTop :nav-sections="navSections" @toggle-sidenav="isSideNavOpen = !isSideNavOpen" />

    <Transition name="layout__view" mode="out-in">
      <RouterView :key="routeKey" class="layout__view" />
    </Transition>

    <NavigationFooter />
    <NavigationSide :nav-sections="navSections" :is-open="isSideNavOpen" @close="isSideNavOpen = false" />
  </div>
</template>

<script>
export default {
  name: 'App',
  metaInfo: {
    title: "Institut de coopération pour l'éducation des adultes"
    /* titleTemplate: '%s | Design' */
  },
  data() {
    return {
      isSideNavOpen: false
    }
  },
  computed: {
    routeKey() {
      const { name, params } = this.$route
      const paramKeys = Object.values(params)
      return paramKeys.length ? `${name}-${paramKeys.join('-')}` : name
    },
    projectLinks() {
      return Object.values(this.$wp.projects)
        .filter(({ isDone, content }) => !isDone && content)
        .map(project => ({
          label: project.shortTitle || project.title,
          route: {
            name: 'project-single',
            params: { projectSlug: project.slug }
          }
        }))
    },
    navSections() {
      return {
        about: {
          label: 'À propos',
          main: {
            title: 'À propos',
            content: 'Un aperçu de ce qui guide nos actions au quotidien.',
            route: { name: 'about' }
          },
          sections: [
            {
              title: `L'institut`,
              links: [
                /* { label: 'Mission et vision', route: { name: 'about' } }, */
                { label: 'Notre équipe', route: { name: 'about-team' } },
                { label: `Historique de l’institut`, route: { name: 'about-history' } }
                /* { label: 'Documents institutionnels', route: { name: 'about-documentation' } } */
              ]
            },
            {
              title: 'Notre réseau',
              links: [
                { label: 'Nos membres', route: { name: 'about-members' } },
                { label: 'Instances et comités', route: { name: 'about-committees' } },
                { label: 'Nos collaborations', route: { name: 'about-collaborations' } }
                /* { label: 'Nous joindre', route: { name: 'contact' } } */
              ]
            }
          ]
        },
        publications: {
          label: 'Publications',
          main: {
            title: 'Publications',
            content: 'Des contenus pour nourrir la réflexion et l’action.',
            route: { name: 'publication-index' }
          },
          sections: [
            {
              title: 'Nouvelles',
              links: [
                { label: 'Nouvelles de l’ICÉA', route: { name: 'news-index' } },
                { label: 'Publications', route: { name: 'publication-index' } }
              ]
            },
            {
              title: 'Revue',
              links: [{ label: 'Apprendre + Agir', url: 'https://icea-apprendreagir.ca/' }]
            }
          ]
        },
        projects: {
          label: 'Projets',
          main: {
            title: 'Projets',
            content: 'Un regard sur les initiatives que nous portons et soutenons.',
            route: { name: 'project-index' }
          },
          sections: [
            {
              title: 'Projets en cours',
              links: this.projectLinks
            }
          ]
        },
        events: {
          label: 'Événements',
          main: {
            title: 'Événements',
            content: 'Nos rendez-vous pour échanger, apprendre et s’engager.',
            route: { name: 'events' }
          },
          sections: [
            {
              title: 'Nos événements',
              links: [{ label: 'Tous les événements', route: { name: 'event-index' } }]
            }
          ]
        },
        resources: {
          label: 'Outils',
          main: {
            title: 'Nos outils',
            content: 'Des ressources pour soutenir et outiller vos démarches.',
            route: { name: 'resources-index' }
          },
          sections: [
            {
              title: 'Outils',
              links: [
                { label: 'Nos compétences fortes', route: { name: 'resources-ncf' } },
                {
                  label: 'Indicateurs de l’éducation des adultes',
                  url: 'https://apprendre-agir.icea.qc.ca/index.php/Indicateurs'
                },
                {
                  label: 'Positionnements stratégiques',
                  url: 'https://apprendre-agir.icea.qc.ca/index.php/Positionnement'
                },
                { label: 'Veille informationelle', route: { name: 'resources-monitoring' } },
                { label: 'Trucs et outils en milieu de travail', route: { name: 'resources-training' } }
              ]
            },
            {
              title: 'Services',
              links: [{ label: 'Services de recherche', route: { name: 'resources-research' } }]
            }
          ]
        }
      }
    }
  }
}
</script>
